<div class="footer-menu">
    <button class="back-btn" mat-button>Back</button>
    <button class="next-btn" mat-raised-button color="primary">Next</button>
</div>

<div fxLayout="row wrap" class="footer-menu">
    <div matRipple matRippleRadius="30" matRippleCentered="true" matRippleUnbounded="true" fxFlex="33.33">
        <mat-icon class="footer-icon active">home</mat-icon>
        <div class="footer-title active">DASHBOARD 1</div>
    </div>

    <div matRipple matRippleRadius="0" matRippleCentered="true" matRippleUnbounded="true" fxFlex="33.33">
        <mat-icon class="footer-icon disable">home</mat-icon>
        <div class="footer-title disable">DASHBOARD 1</div>
    </div>

    <div matRipple matRippleRadius="30" matRippleCentered="true" matRippleUnbounded="true" fxFlex="33.33">
        <mat-icon class="footer-icon">home</mat-icon>
        <div class="footer-title">DASHBOARD 1</div>
    </div>
</div>